import React from 'react';
import { Radio } from 'antd';

export const getOverlayOptions = ({ disableTargetToAMember } = {}) => [
  { label: 'No Target Member', value: 'No Target Member', disabled: false },
  {
    label: 'Target to a Member',
    value: 'Target to a Member',
    disabled: disableTargetToAMember,
  },
];

export const OVERLAY_OPTIONS = getOverlayOptions();

const OverlayOptions = (props) => {
  const { onChange, value, isAllowToViewOverlayProvideData } = props;

  const overlayOptions = getOverlayOptions({
    disableTargetToAMember: !isAllowToViewOverlayProvideData,
  });

  return (
    <div style={{ padding: 10, textAlign: 'center' }}>
      <Radio.Group onChange={onChange} value={value}>
        {overlayOptions.map((option) => (
          <Radio value={option.value} disabled={option?.disabled}>
            {option.label}
          </Radio>
        ))}
      </Radio.Group>
    </div>
  );
};

export default OverlayOptions;
